define('lq/events/actions/excelExportCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'lq',
    'lq/cookie',
    'lq/formSubmission'
], function (EventAction, $, lq, cookie, FormSubmission) {
    'use strict';

    function ExcelExportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExcelExportCommand, EventAction);

    ExcelExportCommand.typeName = 'ExcelExportCommand';

    ExcelExportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ExcelExportCommand.prototype.createEventActionRequest = function() {
        if (this.eventData.downloadOnly)
            return undefined;

        return {
            eventActionType: 'ExcelExport',
            command: this.eventData.command
        };
    };

    ExcelExportCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventData.downloadOnly) {
            var token = 'excel-export-' + Date.now();

            var form = new FormSubmission(this.piping.url.prepare(lq.getTenantUrl('Export/Excel')));
            form.addProperty('actionId', this.piping.actionId);
            form.addProperty('excelExportId', this.eventData.command);
            form.addProperty('token', token);
            form.addParameters('parameters', this.piping.parameters.getNonSystemParameters());
            form.submit();

            var waitWhileDownloadIsStarting = function() {
                if (cookie.get(token) === null)
                    setTimeout(waitWhileDownloadIsStarting, 200);
                else
                    continuation();
            };
            waitWhileDownloadIsStarting();
        } else if (eventActionResponse.download) {
            var queryString = {
                url: eventActionResponse.url,
                filename: eventActionResponse.filename,
                openInBrowser: false
            };
            window.location = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), queryString);
            continuation();
        } else {
            continuation();
        }
    };

    return ExcelExportCommand;
});
